export default __webpack_public_path__ + "static/background-smaller-cfd9daf253f7f85922750020c9f149bf.png";